import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SortComponent from './component';

import { mainSortCategoriesArray } from '../../utils/sortOptions';

class SortContainer extends Component {
  render() {
    const { activeClass, showBorder } = this.props;
    return (
      <SortComponent
        activeClass={activeClass}
        showBorder={showBorder}
        mainSortCategoriesArray={mainSortCategoriesArray}
      />
    );
  }
}
SortContainer.propTypes = { activeClass: PropTypes.string };

SortContainer.defaultProps = { activeClass: '' };

export default SortContainer;
